import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Camera, Filter } from "lucide-react";

const TYPES = [
  { value: "", label: "Semua" },
  { value: "bahan_masuk", label: "Bahan Masuk" },
  { value: "repack", label: "Repack" },
  { value: "shipment_out", label: "Kirim ke Cabang" },
  { value: "shipment_in", label: "Diterima Cabang" },
  { value: "resi_upload", label: "Upload Resi" },
  { value: "dropoff", label: "Drop-Off Logistik" },
];

export default function Activities() {
  const [rows, setRows] = useState([]);
  const [type, setType] = useState("");
  useEffect(() => {
    const q = type ? `?type=${type}` : "";
    api.get(`/activities${q}&limit=200`.replace('?&','?')).then(({ data }) => setRows(data));
  }, [type]);

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs uppercase tracking-widest text-blue-600 font-bold">Bukti & Jejak</p>
        <h1 className="text-3xl font-extrabold text-slate-900" style={{fontFamily:'Manrope'}}>Aktivitas & Foto Bukti</h1>
        <p className="text-sm text-slate-600 mt-1">Setiap aksi terekam foto — anti kecurangan.</p>
      </div>

      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1">
        <Filter size={16} className="text-slate-500 flex-shrink-0" />
        {TYPES.map((t) => (
          <button key={t.value} data-testid={`filter-${t.value || 'all'}`} onClick={() => setType(t.value)} className={`h-9 px-3 rounded-full whitespace-nowrap text-xs font-bold uppercase tracking-wider ${type === t.value ? 'bg-slate-900 text-white' : 'bg-white border border-slate-200 text-slate-700'}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.length === 0 && <p className="text-sm text-slate-500">Belum ada aktivitas.</p>}
        {rows.map((a) => (
          <div key={a.id} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            {a.photo_id ? (
              <img src={fileUrl(a.photo_id)} alt="" className="w-full h-40 object-cover" />
            ) : (
              <div className="w-full h-40 bg-slate-100 flex items-center justify-center text-slate-400"><Camera size={28} /></div>
            )}
            <div className="p-4">
              <p className="text-[10px] font-bold uppercase tracking-widest text-blue-600">{a.type?.replace(/_/g,' ')}</p>
              <p className="mt-1 font-semibold text-slate-900 text-sm truncate">{a.notes || a.created_by_name}</p>
              <p className="text-xs text-slate-500">{a.created_by_name}</p>
              <p className="text-xs text-slate-400">{new Date(a.created_at).toLocaleString('id-ID')}</p>
              {(a.lat && a.lng) && <p className="text-xs text-slate-500 mt-1">📍 {a.lat.toFixed(4)}, {a.lng.toFixed(4)}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
